<template>
  <div :class="updateLocalStorage" class="app-wrapper">
    <HeaderBar v-if="$route.name !== 'LoginView'" />
    <main>
      <router-view />
    </main>
    <FooterBar v-if="$route.name !== 'LoginView'" />
    <create-load-popup></create-load-popup>
    <Toast position="bottom-right" group="app">
      <template #message="slotProps">
        <span :class="iconClass"></span>
        <div class="p-toast-message-text">
        <span class="p-toast-summary">{{ slotProps.message.summary }}</span>
        <div class="p-toast-detail" v-html="slotProps.message.detail" />
        </div>
      </template>
    </Toast> 
  </div>
</template>
<script>
import HeaderBar from "@/components/common/HeaderBar.vue";
import FooterBar from "@/components/common/FooterBar.vue";
import createLoadPopup from "@/components/my-loads/createLoadPopup.vue";
import Toast from "primevue/toast";
import LDIHub from "./LDIHub";
import { getThemeType } from "@/config/themes";

export default {
  data() {
    return {
      currentTheme: this.$store.state.login.theme,
    };
  },
  components: {
    HeaderBar,
    FooterBar,
    createLoadPopup,
    Toast
  },
  methods: {
    handleScroll() {
      if (navigator.userAgent.indexOf("Firefox") != -1 && window.scrollY < 50) {
        document.querySelector("body").classList.add("scrollIssueFirefox");
      }
      else if (navigator.userAgent.indexOf("Firefox") != -1 && window.scrollY > 50) {
        document.querySelector("body").classList.remove("scrollIssueFirefox");
      }
    }
  },
  computed: {
    updateLocalStorage() {
      const { theme, colorVisionType } = this.$store.state.login;

      document.documentElement.className = theme;
      colorVisionType && document.documentElement.classList.add(colorVisionType);

      const themeType = getThemeType(theme); 
      document.documentElement.style.setProperty(
        '--dark',
        themeType === 'dark' ? 1 : 0
      );

      return colorVisionType ? `${theme} ${colorVisionType}` : theme;
    },
    currentRoute() {
      return this.$route.name;
    },
  },
 created () {
    this.emitter.on('appToast', toastParams => { // see "@/appToast.js"
      this.$toast.add(toastParams);
    });
 },
 async mounted() {
    console.log("In mounted");
    LDIHub.start();
    LDIHub.client
      .invoke("SendMessage", "LDI", "Chat started...")
      .then(() => console.log("SendMessage App-Method connected"))
      .catch((err) => console.log("Error while starting method: " + err));

       // already called in nav guard / regex because $route not set properly at this point
      if (document.location.pathname.match(/\/intermodal(?:\/\d+)?(?:\/\d)?/) === null) {
        await this.$store.dispatch('getAllFeaturesAction');
      }
  },
};
</script>

<style lang="scss">
.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  main {
    flex: 1;
  }
}
</style>
